<template>
<section class="input-container">
    <div class="label">
        <p><i class="icon-required" v-if="transProp.validations.presence === '1'">*</i>{{transProp.label}}:</p>
        <van-icon name="question-o" class="question" v-if="transProp.notes" @click="showNotes" />
    </div>
    <div class="inp-f">
        <input type="text" class="inp-s" v-model="address" placeholder="请选择地址" @input="validate" readonly @click="openAddress" name="">
    </div>
    <div class="form-error" v-show="showError">
        {{transProp.label}}不可为空
    </div>
    <van-area :area-list="areaList" v-if="showAddress" @confirm="confirm" @cancel="cancel" />
</section>
</template>

<script>
import {
    Area,
    Icon
} from "vant";
import areaList from "./area.js";
export default {
    props: {
        transProp: Object,
        index: Number
    },
    components: {
        "van-area": Area,
        "van-icon": Icon
    },
    data() {
        return {
            areaList,
            showAddress: false,
            address: "",
            showError: false,
        };
    },
    methods: {
        showNotes() {
            this.$emit('input', this.index)
        },
        collectOptions() {
            let options = {
                code: this.transProp.code,
                value: this.address
            }
            return options;
        },
        openAddress() {
            this.showAddress = true;
        },
        confirm(params) {
            let address = params.map(i => i.name).join("/");
            this.address = address;
            this.showAddress = false;
            this.validate();
        },
        cancel(params) {
            this.showAddress = false;
            // console.log(params)
        },
        validate() {
            if (this.transProp.required) {
                if (!this.address) {
                    this.showError = true;
                     return {
                        label: this.transProp.label,
                        boo: true,
                    }
                } else {
                    this.showError = false;
                     return {
                        label: this.transProp.label,
                        boo: false,
                    }
                }
            } else {
                 return {
                        label: this.transProp.label,
                        boo: false,
                    }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.input-container {
    .label {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .question {
            color: #999090;
            font-size: 32px;
        }
    }

    .inp-f {
        margin: 8px 0;

        .inp-s {
            color: #666;
        }
    }
}
</style>
